
import moment from 'moment';
import momentTZ from 'moment-timezone';


export const formattedDate = (date, format) => {
  return moment.utc(date).format(format);
};

export const addTime = (date, amount, unit) => {
  return moment(date).add(amount, unit).toISOString();
};

export const isToday = (date) => {
  return moment(date).isSame(moment(), 'day');
};

export const toNow = (date) => {
  return moment(date).toNow(true);
};
export const fromNow = (date) => {
  return moment(date).fromNow(true);
};

export const isBeforeNow = (date) => {
  return moment(date).isBefore(moment().utc());
};
export const isAfterNow = (date) => {
  return moment(date).isAfter(moment().utc());
};

export const isValidISO8601String = (date) => {
  return moment(date, moment.ISO_8601).isValid();
};

export const isoString = () => {
  return moment().toISOString();
};

export const unixToISOSting = (t) => {
  return moment(t).toISOString();
};

export const getTimeZones = () => {
  return momentTZ.tz.names();
};
export const getDateFormattedWithTZ = (date, time_zone, format) => {
  if (!date || !time_zone) {
    return '';
  } else {
    if (!format) {
      format = 'MMM DD, YYYY [at] h:mm A z';
    }
    return momentTZ.tz(date, time_zone).format(format);
  }
};

export const formatFullDate = (timestamp, time_zone) => {
  //  const date = new Date(timestamp * 1000); // Convert timestamp to milliseconds
  const date = momentTZ.tz(timestamp, time_zone).toDate(); 
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Get the appropriate suffix for the day (e.g., "1st", "2nd", "3rd", "4th", etc.)
  let daySuffix;
  if (day >= 11 && day <= 13) {
    daySuffix = 'th';
  } else if (day % 10 === 1) {
    daySuffix = 'st';
  } else if (day % 10 === 2) {
    daySuffix = 'nd';
  } else if (day % 10 === 3) {
    daySuffix = 'rd';
  } else {
    daySuffix = 'th';
  }

  return `${month} ${day}${daySuffix}, ${year}`;
}
